<template>
  <div class="gs-billing-info">
    <div class="gs-billing-info__card">
      <div class="gs-billing-info__rows">
        <div class="gs-billing-info__row">
          <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_name') }} : </label>
          <label class="text-sm text-grey-700 ml-2">{{ $store.state.user.name }}</label>
        </div>
        <div class="gs-billing-info__row">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovesell_billing_email') }} :
          </label>
          <label class="text-sm text-grey-700 ml-2">{{ $store.state.user.email }}</label>
        </div>
        <div class="gs-billing-info__row">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovesell_billing_access_level') }} :
          </label>
          <label class="text-sm text-grey-700 ml-2">{{ accessLevel }}</label>
        </div>
        <div v-if="nextBillingDate" class="gs-billing-info__row">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovesell_billing_next_billing_date') }}:
          </label>
          <label class="text-sm text-grey-700 ml-2">{{ nextBillingDate }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.gs-billing-info__card {
  padding: 20px 24px;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  background: var(--gs-surface);
  box-shadow: var(--gs-shadow-sm);
}

.gs-billing-info__rows {
  display: grid;
  gap: 14px;
}

.gs-billing-info__row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--gs-border);
}

.gs-billing-info__row:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.gs-billing-info__row label:first-child {
  color: var(--gs-muted-foreground);
  font-size: 13px;
  font-weight: 700;
}

.gs-billing-info__row label:last-child {
  color: var(--gs-foreground);
  font-size: 14px;
}

@media (max-width: 640px) {
  .gs-billing-info__card {
    padding: 16px;
  }
}
</style>

<script>

export default {
  name: 'Info',
  props: {
    accessLevel: {
      required: true
    },
    nextBillingDate: {
      required: true
    }
  },
};
</script>
